const userResponseToUserObject = (response) => {
    return {
        id: response.id,
        email: response.email,
        firstName: response.first_name,
        lastName: response.last_name,
        roles: response.roles,
    };
};

export { userResponseToUserObject };
